export const plData = {
  title: 'INFORMACJA O PLIKACH COOKIE',
  sections: [
    {
      title: 'Jak wykorzystujemy pliki cookie i podobne technologie',
      content: `

      `
    },
    {
      title: '1. Czym są pliki cookie?',
      content: `
<p>Pliki cookie to niewielkie pliki tekstowe przesyłane z naszych stron internetowych, aplikacji lub usług i przechowywane na Twoim urządzeniu. Strony internetowe Danghuan, usługi online, aplikacje, usługi interaktywne, wiadomości e-mail oraz reklamy mogą wykorzystywać pliki cookie i podobne technologie, takie jak znaczniki pikselowe (pixel tags) i sygnalizatory sieciowe (web beacons). Nie mamy dostępu do plików cookie, które nie zostały ustawione przez nasze strony internetowe lub usługi.</p>

      `
    },
    {
      title: '2. Jak długo pliki cookie pozostają na Twoim urządzeniu?',
      content: `
<p><strong>(1) Sesyjne pliki cookie</strong></p>
<p>Te pliki cookie pozostają na urządzeniu tylko do momentu zamknięcia przeglądarki i nie są na nim przechowywane na stałe. Sesyjne pliki cookie są zazwyczaj wykorzystywane do śledzenia stron odwiedzanych podczas danej sesji przeglądania w celu dostosowania doświadczenia użytkownika podczas tej wizyty.</p>
<p><strong>(2) Trwałe pliki cookie</strong></p>
<p>Te pliki cookie pozostają zapisane na urządzeniu do momentu ich ręcznego usunięcia lub automatycznego wygaśnięcia. Trwałe pliki cookie mogą być wykorzystywane do zapamiętywania Twoich preferencji podczas kolejnych wizyt na naszej stronie internetowej.</p>

      `
    },
    {
      title: '3. Wykorzystujemy następujące rodzaje plików cookie',
      content: `
<p><strong>(1) Ściśle niezbędne pliki cookie</strong></p>
<p>Te pliki cookie są niezbędne do prawidłowego działania naszej strony internetowej i usług. Mogą obejmować pliki cookie umożliwiające dostęp do bezpiecznych obszarów strony internetowej, utrzymywanie sesji lub zapobieganie oszustwom.</p>
<p><strong>(2) Analityczne lub wydajnościowe pliki cookie</strong></p>
<p>Te pliki cookie umożliwiają nam zliczanie odwiedzających oraz analizowanie sposobu, w jaki użytkownicy korzystają z naszej strony internetowej, dzięki czemu możemy poprawiać jej wydajność, funkcjonalność oraz komfort użytkowania.</p>
<p><strong>(3) Funkcjonalne pliki cookie</strong></p>
<p>Te pliki cookie umożliwiają rozpoznanie użytkownika podczas ponownej wizyty na naszej stronie internetowej oraz pozwalają nam personalizować treści i zapamiętywać jego preferencje, takie jak wybrany język.</p>
<p><strong>(4) Pliki cookie związane z reklamą behawioralną</strong></p>
<p>Te pliki cookie rejestrują Twoją wizytę na naszej stronie internetowej, odwiedzane strony oraz klikane linki. Możemy wykorzystywać te informacje w celu lepszego dostosowania naszej strony internetowej i reklam do Twoich zainteresowań. Jeżeli jest to prawnie dozwolone, możemy również udostępniać te informacje podmiotom trzecim w celach reklamowych.</p>

      `
    },
    {
      title: '4. W jaki sposób wykorzystujemy pliki cookie',
      content: `
<p>(1) My oraz nasi partnerzy możemy wykorzystywać pliki cookie i podobne technologie w celu lepszego zrozumienia funkcjonowania naszej strony internetowej, usług oraz platform mobilnych, w tym:</p>
<ul>
  <li>częstotliwości korzystania z naszych usług;</li>
  <li>zachowania użytkowników podczas przeglądania;</li>
  <li>danych dotyczących wydajności i danych technicznych;</li>
  <li>źródeł ruchu;</li>
  <li>interakcji z reklamami;</li>
  <li>informacji o urządzeniu i przeglądarce.</li>
</ul>
<p>Nie łączymy bezpośrednio danych pochodzących z analitycznych plików cookie z informacjami umożliwiającymi identyfikację konkretnej osoby, chyba że jest to dozwolone przez prawo.</p>
<p>(2) My oraz nasi partnerzy możemy wykorzystywać pliki cookie i podobne technologie do analizowania trendów, administrowania stronami internetowymi, monitorowania aktywności użytkowników oraz gromadzenia zagregowanych informacji demograficznych dotyczących naszej bazy użytkowników.</p>
<p>(3) Jeżeli funkcja „Do Not Track” („Nie śledź”) jest włączona w Twojej przeglądarce, będziemy respektować ustawienia przeglądarki w zakresie wymaganym przez obowiązujące przepisy prawa.</p>
<p>(4) Podobnie jak większość stron internetowych, automatycznie gromadzimy określone informacje techniczne, w tym:</p>
<ul>
  <li>adres IP;</li>
  <li>typ przeglądarki;</li>
  <li>dostawcę usług internetowych;</li>
  <li>strony odsyłające i strony wyjścia;</li>
  <li>przeglądane pliki i strony;</li>
  <li>system operacyjny;</li>
  <li>datę i godzinę;</li>
  <li>dane dotyczące sekwencji kliknięć.</li>
</ul>
<p>(5) Możemy współpracować z zewnętrznymi dostawcami usług reklamowych i analitycznych w celu wyświetlania reklam na naszej stronie internetowej lub zarządzania reklamami na stronach internetowych podmiotów trzecich.</p>
<p>Partnerzy ci mogą wykorzystywać pliki cookie lub podobne technologie w celu dostarczania reklam na podstawie Twojej aktywności podczas przeglądania oraz zainteresowań.</p>
<p>Możesz zarządzać reklamowymi plikami cookie lub je wyłączyć za pomocą ustawień przeglądarki lub preferencji dotyczących plików cookie.</p>
<p>Należy pamiętać, że wyłączenie spersonalizowanych reklam nie oznacza całkowitego zaprzestania wyświetlania reklam..</p>

      `
    },
    {
      title: '5. Usuwanie lub wyłączanie plików cookie',
      content: `
<p>Możesz zarządzać preferencjami dotyczącymi plików cookie za pomocą ustawień przeglądarki lub naszego banera cookie.</p>
<p>Informacje dotyczące zarządzania plikami cookie można znaleźć w instrukcjach dostawcy używanej przeglądarki, w tym:</p>
<ul>
  <li>Microsoft Internet Explorer</li>
  <li>Microsoft Edge</li>
  <li>Mozilla Firefox</li>
  <li>Google Chrome</li>
  <li>Safari dla macOS</li>
  <li>Safari dla iOS</li>
</ul>
<p>Należy pamiętać, że wyłączenie plików cookie może wpłynąć na działanie niektórych części naszych Usług.</p>

      `
    },
    {
      title: '6. Dodatkowe informacje dotyczące plików cookie',
      content: `
<p>Więcej informacji na temat plików cookie oraz sposobu skonfigurowania przeglądarki w celu ich akceptowania, odrzucania lub usuwania można znaleźć w serwisie: <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a></p>
<p>Prosimy również o zapoznanie się z naszą Polityką Prywatności, aby uzyskać dodatkowe informacje dotyczące przetwarzania danych osobowych.</p>

      `
    },
    {
      title: 'Szczegółowe informacje dotyczące plików cookie',
      content: `
<p>Poniższa tabela przedstawia przykłady plików cookie, które mogą być wykorzystywane na stronie internetowej Danghuan:</p>

        <table>
          <thead>
            <tr>
              <th>Typ</th>
              <th>Nazwa</th>
              <th>Domena / Dostawca</th>
              <th>Cel</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Niezbędne</td>
              <td>session_id</td>
              <td>danghuan.eu</td>
              <td>Utrzymywanie sesji użytkownika i uwierzytelnianie</td>
            </tr>
            <tr>
              <td>Niezbędne</td>
              <td>cookiesaccepted</td>
              <td>danghuan.eu</td>
              <td>Przechowywanie preferencji dotyczących zgody na pliki cookie</td>
            </tr>
            <tr>
              <td>Niezbędne</td>
              <td>XSRF-TOKEN</td>
              <td>danghuan.eu</td>
              <td>Bezpieczeństwo i zapobieganie oszustwom</td>
            </tr>
            <tr>
              <td>Niezbędne</td>
              <td>stayOnSite</td>
              <td>danghuan.eu</td>
              <td>Zapamiętywanie wyboru regionu lub strony</td>
            </tr>
            <tr>
              <td>Funkcjonalne</td>
              <td>language_pref</td>
              <td>danghuan.eu</td>
              <td>Przechowywanie preferencji językowych</td>
            </tr>
            <tr>
              <td>Analityczne</td>
              <td>_ga</td>
              <td>Google Analytics</td>
              <td>Rozróżnianie użytkowników i analiza ruchu</td>
            </tr>
            <tr>
              <td>Analityczne</td>
              <td>_gid</td>
              <td>Google Analytics</td>
              <td>Rozróżnianie użytkowników</td>
            </tr>
            <tr>
              <td>Analityczne</td>
              <td>_gat</td>
              <td>Google Analytics</td>
              <td>Regulowanie częstotliwości żądań</td>
            </tr>
            <tr>
              <td>Analityczne</td>
              <td>_hjSession</td>
              <td>Hotjar</td>
              <td>Analiza strony internetowej i mapy cieplne</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>_fbp</td>
              <td>Meta/Facebook</td>
              <td>Śledzenie reklam i konwersji</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>fr</td>
              <td>Meta/Facebook</td>
              <td>Dopasowanie i wyświetlanie reklam</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>personalisation_id</td>
              <td>X (Twitter)</td>
              <td>Reklama i identyfikacja użytkownika</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>_ttp</td>
              <td>TikTok</td>
              <td>Reklama i śledzenie użytkownika</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>test_cookie</td>
              <td>DoubleClick</td>
              <td>Optymalizacja reklam</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>IDE</td>
              <td>DoubleClick</td>
              <td>Spersonalizowane reklamy</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>ANID</td>
              <td>Google</td>
              <td>Preferencje reklamowe</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>AID</td>
              <td>Google Ads</td>
              <td>Analityka i reklama</td>
            </tr>
            <tr>
              <td>Reklamowe</td>
              <td>g</td>
              <td>SmartNews Ads</td>
              <td>Spersonalizowane reklamy</td>
            </tr>
          </tbody>
        </table>
      `
    },
    {
      title: '7. Zarządzanie plikami cookie',
      content: `
<p>Możesz skonfigurować swoją przeglądarkę tak, aby blokowała pliki cookie lub informowała Cię o ich użyciu. Należy jednak pamiętać, że po wyłączeniu niektórych plików cookie część naszej strony internetowej lub naszych usług może nie działać prawidłowo.</p>
<p>Możesz również zarządzać swoimi preferencjami dotyczącymi plików cookie za pośrednictwem naszego banera cookie lub ustawień prywatności, jeśli są dostępne.</p>

      `
    }
  ]
};
